// @flow

import {Environment} from 'relay-runtime'
import {commitMutation, graphql, } from 'react-relay'

const mutation = graphql`
    mutation TVShowOrderEditMutation(
        $input: TVShowOrderEditInput!
    ) {
        TVShowOrderEdit(input: $input) {
            tvshow {
                id,
                title
                order
            }
        }
    }
`

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
    commitMutation(
        environment, 
        {
            mutation: mutation,
            variables: {
                input: params
            },
            onCompleted: (response) =>{
                console.log(response)
                if (response.error !== null) {
                    callback(response.error, null)
                    return
                }

                callback(null, response.tvshow.id)
            },
            onError: (error) => {
                console.log("error mutating")
                console.log(error)
                callback(error, null)
            },
        })
}


// WEBPACK FOOTER //
// src/mutations/TVShowOrderEditMutation.js